<template>
    <div
        class="mt-2"
    >
        <v-flex
            lg4
            md6
            sm8
            v-cloak
            v-if="personId"
            xs12
        >
            <v-toolbar
                class="elevation-1 white--text"
                color="primary"
                height="50px"
            >
                <v-toolbar-title>
                    <v-icon class="white--text">fa-team-card</v-icon>
                    Team
                </v-toolbar-title>
                <v-divider
                    class="mx-2"
                    inset
                    vertical
                />
                <v-spacer />
                <EditPersonTeamDialog :person-id="personId" />
            </v-toolbar>
            <v-card>

                <v-simple-table
                    class="table"
                    id="personTeamTable"
                    style="table-layout:fixed;"
                >
                    <tbody style="table-layout: fixed">
                    <tr>
                        <td>
                            <div class="py-3">Team</div>
                        </td>
                        <td>{{ personTeam.team.name }}</td>
                    </tr>
                    </tbody>
                </v-simple-table>
            </v-card>
        </v-flex>
        <v-flex
            lg4
            md6
            sm8
            v-cloak
            v-else
            xs12
        >
            Person not retrieved from database
        </v-flex>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    //import {FETCH_PERSON_TEAM} from "@/store/person_team/actions";
    // import {FETCH_PERSONNEL_COUNTRY_LIST} from "@/store/personnel_country/actions.js";
    import EditPersonTeamDialog from "./EditPersonTeamDialog";

    export default {
        name: "PersonTeam",
        components: {
            EditPersonTeamDialog,
        },

        props: {
            personId: {
                type: Number,
                required: true,
            },
        },

        data: function () {
            return {
                namespace: "personPersonSummarys",
            };
        },

        computed: {
            ...mapGetters(
            [
                "person",
                "personTeam",
                "countryList",
                "ecsCompanyList",
                "jobList",
                "teamList",
                "getTeamNameById",
            ]
            )
        },

        mounted() {
            if (this.personId) {
                //this.fetchPersonnelCountryList();
                //this.fetchPersonTeam();
            }
        },

        methods: {
            // fetchPersonTeam() {
            //     this.$store.dispatch(FETCH_PERSON_TEAM, this.personId);
            // },
            // fetchPersonnelCountryList() {
            //     this.$store.dispatch(FETCH_PERSONNEL_COUNTRY_LIST);
            // },
        }

    }
</script>

<style>
    #personTeamTable > div > table {
        table-layout: fixed !important;
    }
</style>
